<div class="snackBar-container">
    <span> {{ data }} </span>
</div>
